import axios, { AxiosError, AxiosResponse } from 'axios';
import { interceptor } from '../../../utils/axios.interceptor';
import {
  uploadRegistrosDjaEndPoint,
  uploadRegistrosPmEndPoint,
  getLastRegistrosEndPoint,
  getLastDatesRegistrosEndPoint,
} from '../../../utils/endPoints';

export interface ILastDatesRegistros {
  lastDjaDate: string | null;
  lastRpmDate: string | null;
}

export const importadorInstance = axios.create();
interceptor(importadorInstance);

export class ImportadorService {
  /**
   * Used to upload file xlsx registro PM
   * @returns file upload
   */
  async uploadRegistroPM(registroPM: File): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      const response = await importadorInstance.post(
        uploadRegistrosPmEndPoint,
        { registroPM: registroPM },
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      return {
        status: true,
        data: response.data.results,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }

  /**
   * Used to upload file xlsx registro DJA
   * @returns file upload
   */
  async uploadRegistroDJA(registroDJA: File): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      const response = await importadorInstance.post(
        uploadRegistrosDjaEndPoint,
        { djas: registroDJA },
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      return {
        status: true,
        data: response.data.results,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }

  /**
   * Used to get the last file PM in file excel,
   * in the queryparam  1 is the last PM and 0 is the last DJA
   * @returns file excel
   */
  async getLastRegistro(queryParams: object): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      let result;
      const response = await importadorInstance.get(getLastRegistrosEndPoint, {
        params: queryParams,
        responseType: 'blob',
      });
      if (response.status === 200) {
        result = { status: true, data: response.data };
      } else {
        result = { status: false, data: [] };
      }
      return result;
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }

  async getLastDatesRegistros(): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      let result;
      const response = await importadorInstance.get<ILastDatesRegistros>(
        getLastDatesRegistrosEndPoint,
      );
      if (response.status === 200) {
        result = { status: true, data: response.data };
      } else {
        result = { status: false, data: [] };
      }
      return result;
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
}
